import { Fragment } from "react";
import SenderDetails from "../SenderDetails";
import ReceiverDetails from "../ReceiverDetails";
import ParcelInfo from "../ParcelPoint/ParcelInfo";

const KioskForm = ({ type }) => {
    return <Fragment>
        <SenderDetails />
        <div style={{ margin: "3vh" }} />
        {(type.includes('pp_')) && (<ParcelInfo type={type }/>)}
        <div style={{ margin: "1vh" }} />
        <ReceiverDetails type={type}/>
    </Fragment>
}

export default KioskForm;